import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Only run on client side
    if (typeof window !== 'undefined') {
      // @ts-ignore
      if (window.fbq) return;
      // @ts-ignore
      window.fbq = function () {
        // @ts-ignore
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      // @ts-ignore
      if (!window._fbq) window._fbq = window.fbq;
      // @ts-ignore
      window.fbq.push = window.fbq;
      // @ts-ignore
      window.fbq.loaded = true;
      // @ts-ignore
      window.fbq.version = '2.0';
      // @ts-ignore
      window.fbq.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      // @ts-ignore
      window.fbq('init', '1181648490064668');
      // @ts-ignore
      window.fbq('track', 'PageView');
    }
  }, []);
  return <noscript data-id="element-209">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1181648490064668&ev=PageView&noscript=1" alt="" data-id="element-210" />
    </noscript>;
}